import {Component, input} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';

interface LogoProps {
  src?: string;
  alt?: string;
  text?: string;
  url?: string;
}

const defaultLogoProps: LogoProps = {
  src: '/img/logo.png',
  alt: 'Logo',
  text: 'Logo',
  url: '/'
};

@Component({
  selector: 'app-logo',
  template: `
    @if (vm.url) {
      <a [href]="vm.url">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
      </a>
    } @else {
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    }

    <ng-template #logo>
      @if (vm.text) {
        {{ vm.text }}
      } @else {
        <img [src]="vm.src" alt="vm.alt">
      }
    </ng-template>

  `,
  imports: [
    NgTemplateOutlet
  ]
})
export class LogoComponent {
  config = input(defaultLogoProps);

  get vm() {
    return this.config();
  }
}
